// #644 originally trimmed this to one decimal ("68.5") for read-aloud
// brevity; #807 (Evin) overrides that — dressage percentages must ALWAYS
// show the full 3-decimal precision score-common's calculateRideComposite
// produces, matching score-common's formatPercentage (single source of
// truth for percentage rendering, minus the trailing "%" — the i18n
// strings here append that themselves).
export function formatComposite(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n.toFixed(3) : "";
}

export default formatComposite;
